import "./filters.css";
import { useEffect, useState, useRef } from "react";
import Input from "../formBasic/Input";
import CalendarFilter from "../../../assets/svgs/calendaFilter.svg";
import SearchFilterIcon from "../../../assets/svgs/searchFilter.svg";
import Filter from "../../../assets/img/filter.png";
import LixoIcon from "../../../assets/svgs/lixo.svg";
import IconAlert from "../../../assets/svgs/icon-alert.svg";
import { CalendarInput } from "../../calendarInput/Calendarinput";
import ContainerError from "../../error/containerError";
import {
  getCenter,
  getClassifications,
  getClassificationsTax,
} from "../../../redux/actions/fluxoNSimilar";
import { useDispatch } from "react-redux";
import InputCheckBox from "../../inputCheckBox/inputCheckBox";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import usePersistedState from "../../../hooks/usePersistedState";
import useDateRangeValidation from "../../../hooks/useDateRangeValidation";
import { useRoles } from "../../../hooks/roles";
import {
  optionsFlag,
  OptionsStatus,
  OptionsFlag,
  getRestrictedOptionsStatus,
  optionsHamonizado,
  OptionsHarmon,
  OptionsCenter,
} from "../../../utils/optionsAutocomplete";
import { clearStatus } from "../../../redux/slices/sessionSlice";
import { BaseFilterPage } from "../../../types/filterPage";
import { validateDateRange } from "../../../utils/dateUtils";

export interface FilterPage extends BaseFilterPage {
  setFilter?: any;
}

const Filters = ({
  setMaterialPartNumber,
  materialPartNumber,
  setMaterialPartDesc,
  materialPartDesc,
  centerFilter,
  setCenterFilter,
  setStartDate,
  startDate,
  endDate,
  setEndDate,
  classificationQuizStartDate,
  setClassificationQuizStartDate,
  classificationQuizFinishDate,
  setClassificationQuizFinishDate,
  classificationApprovalStartDate,
  setClassificationApprovalStartDate,
  classificationApprovalEndDate,
  setClassificationApprovalEndDate,
  selectedOptionsStatus,
  setSelectedOptionsStatus,
  selectedOptionsCenter,
  setSelectedOptionsCenter,
  selectedOptionsFlag,
  setSelectedOptionsFlag,
  selectedOptionsHarmon,
  setSelectedOptionsHarmon,
  handleFilter,
  emitentePartNumber,
  setEmitentePartDesc,
  setPage,
  setPageSize,
  setFilter,
}: FilterPage) => {
  const dispatch = useDispatch();
  const { isTax, isEngineer } = useRoles();
  const [calendarKey, setCalendarKey] = useState(0);
  const [quizCalendarKey, setQuizCalendarKey] = useState(0);
  const [approvalCalendarKey, setApprovalCalendarKey] = useState(0);
  const [startDateLocal, setStartDateLocal] = usePersistedState(
    "startDate",
    startDate
  );
  const [endDateLocal, setEndDateLocal] = usePersistedState("endDate", endDate);
  const [classificationQuizStartDateLocal, setClassificationQuizStartDateLocal] =
    usePersistedState(
      "classificationQuizStartDate",
      classificationQuizStartDate
    );
  const [classificationQuizFinishDateLocal, setClassificationQuizFinishDateLocal] =
    usePersistedState(
      "classificationQuizFinishDate",
      classificationQuizFinishDate
    );
  const [
    classificationApprovalStartDateLocal,
    setClassificationApprovalStartDateLocal,
  ] = usePersistedState(
    "classificationApprovalStartDate",
    classificationApprovalStartDate
  );
  const [
    classificationApprovalEndDateLocal,
    setClassificationApprovalEndDateLocal,
  ] = usePersistedState(
    "classificationApprovalEndDate",
    classificationApprovalEndDate
  );
  const [dateRange, setDateRange] = useState<[string, string]>(() => {
    const safeStart =
      startDateLocal && startDateLocal.trim() !== "" ? startDateLocal : "";
    const safeEnd =
      endDateLocal && endDateLocal.trim() !== "" ? endDateLocal : "";
    return [safeStart, safeEnd];
  });
  const [quizDateRange, setQuizDateRange] = useState<[string, string]>(() => {
    const safeStart =
      classificationQuizStartDateLocal &&
      classificationQuizStartDateLocal.trim() !== ""
        ? classificationQuizStartDateLocal
        : "";
    const safeEnd =
      classificationQuizFinishDateLocal &&
      classificationQuizFinishDateLocal.trim() !== ""
        ? classificationQuizFinishDateLocal
        : "";
    return [safeStart, safeEnd];
  });
  const [approvalDateRange, setApprovalDateRange] = useState<[
    string,
    string,
  ]>(() => {
    const safeStart =
      classificationApprovalStartDateLocal &&
      classificationApprovalStartDateLocal.trim() !== ""
        ? classificationApprovalStartDateLocal
        : "";
    const safeEnd =
      classificationApprovalEndDateLocal &&
      classificationApprovalEndDateLocal.trim() !== ""
        ? classificationApprovalEndDateLocal
        : "";
    return [safeStart, safeEnd];
  });

  const restriction = getRestrictedOptionsStatus(isTax, isEngineer);

  const [materialPartNumberError, setMaterialPartNumberError] = useState("");
  const [materialPartDescError, setMaterialPartDescError] = useState("");
  const [, setCenterFilterError] = useState("");
  const [emitenteDescError, setEmitenteDescErrorr] = useState("");
  const [, setErrorApi] = useState(false);
  const [dateError, setDateError] = useState(() =>
    validateDateRange(startDateLocal || "", endDateLocal || "")
  );
  const [quizDateError, setQuizDateError] = useState(() =>
    validateDateRange(
      classificationQuizStartDateLocal || "",
      classificationQuizFinishDateLocal || ""
    )
  );
  const [approvalDateError, setApprovalDateError] = useState(() =>
    validateDateRange(
      classificationApprovalStartDateLocal || "",
      classificationApprovalEndDateLocal || ""
    )
  );
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isQuizCalendarOpen, setIsQuizCalendarOpen] = useState(false);
  const [isApprovalCalendarOpen, setIsApprovalCalendarOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [centerInputValue, setCenterInputValue] = useState(""); // exclusivo do Centro

  const [restrictionCenter, setRestrictionCenter] = useState<OptionsCenter[]>(
    []
  );
  const [, setSelectedOptionsT] = useState<Option[]>(() => {
    return [];
  });
  const MAX_LENGTH = 50;

  const materialPartNumberInputRef = useRef<HTMLInputElement>(null);
  const materialPartDescInputRef = useRef<HTMLInputElement>(null);
  const emitenteInputRef = useRef<HTMLInputElement>(null);

  const { handleDateChange, handleTypingChange } = useDateRangeValidation(
    setStartDate,
    setEndDate,
    setDateError,
  );
  const {
    handleDateChange: handleQuizDateChange,
    handleTypingChange: handleQuizTypingChange,
  } = useDateRangeValidation(
    setClassificationQuizStartDate ?? (() => {}),
    setClassificationQuizFinishDate ?? (() => {}),
    setQuizDateError,
  );
  const {
    handleDateChange: handleApprovalDateChange,
    handleTypingChange: handleApprovalTypingChange,
  } = useDateRangeValidation(
    setClassificationApprovalStartDate ?? (() => {}),
    setClassificationApprovalEndDate ?? (() => {}),
    setApprovalDateError,
  );

  useEffect(() => {
    setDateRange([startDateLocal || "", endDateLocal || ""]);
    setDateError(validateDateRange(startDateLocal || "", endDateLocal || ""));
  }, [startDateLocal, endDateLocal]);

  useEffect(() => {
    setQuizDateRange([
      classificationQuizStartDateLocal || "",
      classificationQuizFinishDateLocal || "",
    ]);
    setQuizDateError(
      validateDateRange(
        classificationQuizStartDateLocal || "",
        classificationQuizFinishDateLocal || ""
      )
    );
  }, [classificationQuizStartDateLocal, classificationQuizFinishDateLocal]);

  useEffect(() => {
    setApprovalDateRange([
      classificationApprovalStartDateLocal || "",
      classificationApprovalEndDateLocal || "",
    ]);
    setApprovalDateError(
      validateDateRange(
        classificationApprovalStartDateLocal || "",
        classificationApprovalEndDateLocal || ""
      )
    );
  }, [classificationApprovalStartDateLocal, classificationApprovalEndDateLocal]);

  const clearFilters = async () => {
    clearStatus();
    clearCenter();
    setCenterInputValue("");
    setSelectedOptionsStatus?.([]);
    setSelectedOptionsCenter?.([]);
    setPage(1);
    setPageSize?.(5);
    setMaterialPartNumber("");
    setMaterialPartDesc("");
    setCenterFilter("");
    setCenterFilterError("");
    setSelectedOptionsFlag?.([]);
    setSelectedOptionsHarmon?.([]);
    setDateRange(["", ""]);
    setQuizDateRange(["", ""]);
    setApprovalDateRange(["", ""]);
    setStartDate("");
    setEndDate("");
    setClassificationQuizStartDate?.("");
    setClassificationQuizFinishDate?.("");
    setClassificationApprovalStartDate?.("");
    setClassificationApprovalEndDate?.("");
    setEmitentePartDesc?.("");
    setEmitenteDescErrorr("");
    setStartDateLocal("");
    setEndDateLocal("");
    setClassificationQuizStartDateLocal("");
    setClassificationQuizFinishDateLocal("");
    setClassificationApprovalStartDateLocal("");
    setClassificationApprovalEndDateLocal("");
    setCalendarKey((prevKey) => prevKey + 1);
    setQuizCalendarKey((prevKey) => prevKey + 1);
    setApprovalCalendarKey((prevKey) => prevKey + 1);
    setDateError("");
    setQuizDateError("");
    setApprovalDateError("");
    setErrorApi(false);
    setMaterialPartNumberError("");
    setMaterialPartDescError("");
    setInputValue("");
    setSelectedOptionsT([]);

    localStorage.removeItem("materialPartDesc");
    localStorage.removeItem("materialPartNumber");
    localStorage.removeItem("selectValue");
    localStorage.removeItem("selectedStatus");
    localStorage.removeItem("selectedCenter");
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    localStorage.removeItem("classificationQuizStartDate");
    localStorage.removeItem("classificationQuizFinishDate");
    localStorage.removeItem("classificationApprovalStartDate");
    localStorage.removeItem("classificationApprovalEndDate");
    localStorage.removeItem("centerFilter");
    localStorage.removeItem("emitentePartNumber");
    localStorage.removeItem("selectedFlag");
    localStorage.removeItem("selectedHarmon");

    if (isTax) {
      setEmitenteDescErrorr("");
      setEmitentePartDesc("");
      await dispatch(
        getClassificationsTax({
          status: "",
          flag: "",
          ncmHarmonizationAlert: "",
          productCode: "",
          emitter: "",
          center: "",
          presentationName: "",
          startDate: "",
          endDate: "",
          classificationQuizStartDate: "",
          classificationQuizFinishDate: "",
          classificationApprovalStartDate: "",
          classificationApprovalEndDate: "",
          page: 1,
          size: 5,
          sortBy: "",
          sortDirection: "desc",
        })
      );
    } else {
      await dispatch(
        getClassifications({
          status: "",
          center: "",
          productCode: "",
          presentationName: "",
          emitter: "",
          startDate: "",
          endDate: "",
          classificationQuizStartDate: "",
          classificationQuizFinishDate: "",
          classificationApprovalStartDate: "",
          classificationApprovalEndDate: "",
          page: 1,
          size: 5,
          sortBy: "",
          sortDirection: "desc",
        })
      );
    }
  };

  const clearState = async () => {
    setSelectedOptionsStatus?.([]);
    setPage(1);
    setCalendarKey((prevKey) => prevKey + 1);
    setDateError("");
    setInputValue("");
    setSelectedOptionsT([]);
  };

  const clearFlag = async () => {
    setPage(1);
    setCalendarKey((prevKey) => prevKey + 1);
    setDateError("");
    setInputValue("");
    setSelectedOptionsFlag?.([]);
  };

  const clearHarmon = async () => {
    setPage(1);
    setCalendarKey((prevKey) => prevKey + 1);
    setDateError("");
    setInputValue("");
    setSelectedOptionsHarmon?.([]);
  };

  const clearCenter = async () => {
    setPage(1);
    setCalendarKey((prevKey) => prevKey + 1);
    setDateError("");
    setErrorApi(false);
    setInputValue("");
    setSelectedOptionsCenter?.([]);
  };

  type Option = OptionsStatus | OptionsFlag | OptionsHarmon | OptionsCenter;

  const isFilterButtonDisabled = isTax
    ? (selectedOptionsStatus?.length === 0 &&
        selectedOptionsFlag?.length === 0 &&
        selectedOptionsHarmon?.length === 0 &&
        selectedOptionsCenter?.length === 0 &&
        !materialPartNumber &&
        !materialPartDesc &&
        !emitentePartNumber &&
        !centerFilter &&
        !startDate &&
        !endDate &&
        !classificationQuizStartDate &&
        !classificationQuizFinishDate &&
        !classificationApprovalStartDate &&
        !classificationApprovalEndDate) ||
      Boolean(dateError) ||
      Boolean(quizDateError) ||
      Boolean(approvalDateError)
    : (selectedOptionsStatus?.length === 0 &&
        selectedOptionsCenter?.length === 0 &&
        !materialPartNumber &&
        !materialPartDesc &&
        !emitentePartNumber &&
        !startDate &&
        !centerFilter &&
        !endDate &&
        !classificationQuizStartDate &&
        !classificationQuizFinishDate &&
        !classificationApprovalStartDate &&
        !classificationApprovalEndDate) ||
      Boolean(dateError) ||
      Boolean(quizDateError) ||
      Boolean(approvalDateError);

  const handleMaterialPartNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;

    if (value.length === MAX_LENGTH) {
      setMaterialPartNumberError("Limite de 50 caracteres atingido.");
    } else {
      setMaterialPartNumberError("");
    }

    setErrorApi(false);
    setMaterialPartNumber(value);
  };

  const handleMaterialPartDescChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;

    if (value.length === MAX_LENGTH) {
      setMaterialPartDescError("Limite de 50 caracteres atingido.");
    } else {
      setMaterialPartDescError("");
    }

    setErrorApi(false);
    setMaterialPartDesc(value);
  };

  const handleEmitenteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value.length === MAX_LENGTH) {
      setEmitenteDescErrorr("Limite de 50 caracteres atingido.");
    } else {
      setEmitenteDescErrorr("");
    }

    setErrorApi(false);
    setEmitentePartDesc?.(value);
  };

  const inputStyle = { paddingTop: "16.5px" };

  const handleCenterSearch = async (value: string) => {
    if (!value || value.length < 3) {
      setRestrictionCenter([]);
      return;
    }

    try {
      const raw = await dispatch(getCenter({ id: value })).unwrap();

      const mapped = Array.isArray(raw)
        ? raw.map((item: any) => ({
            label: String(item.center),
            value: String(item.center),
          }))
        : [];

      setRestrictionCenter(mapped);
    } catch {
      setRestrictionCenter([]);
    }
  };

  return (
    <>
      <div className="containerFilters">
        <div>
          <Input
            id="material-part-number"
            label=""
            placeholder="Part Number"
            inputStyle={inputStyle}
            img={SearchFilterIcon}
            value={materialPartNumber}
            onChange={handleMaterialPartNumberChange}
            aria-required="true"
            aria-describedby="Material/Part Number"
            inputRef={materialPartNumberInputRef}
            maxLength={50}
          />

          {materialPartNumberError && (
            <ContainerError
              id="material-part-number-error containerErro"
              label={materialPartNumberError}
              icon={IconAlert}
              widthError=""
              backgroudError={"#D1E4FF"}
              colorError={"#000000"}
            />
          )}
        </div>

        <div>
          <Input
            id="material-part-desc"
            label=""
            placeholder="Descrição"
            inputStyle={inputStyle}
            img={SearchFilterIcon}
            value={materialPartDesc}
            onChange={handleMaterialPartDescChange}
            aria-describedby="Nome técnico/Descrição"
            inputRef={materialPartDescInputRef}
            maxLength={50}
          />

          {materialPartDescError && (
            <ContainerError
              id="material-part-desc-error containerErro"
              label={materialPartDescError}
              icon={IconAlert}
              backgroudError={"#D1E4FF"}
              widthError=""
              colorError={"#000000"}
            />
          )}
        </div>

        {(isTax || isEngineer) && (
          <div>
            <Input
              id="material-part-desc"
              label=""
              placeholder="Emitente"
              img={SearchFilterIcon}
              value={emitentePartNumber}
              onChange={handleEmitenteChange}
              aria-describedby="Emitente"
              inputRef={emitenteInputRef}
              maxLength={50}
            />

            {emitenteDescError && (
              <ContainerError
                id="material-part-desc-error containerErro"
                label={emitenteDescError}
                icon={IconAlert}
                backgroudError={"#D1E4FF"}
                widthError=""
                colorError={"#000000"}
              />
            )}
          </div>
        )}

        <div>
          <InputCheckBox
            value={selectedOptionsCenter || []}
            onChange={(_, newValue) =>
              setSelectedOptionsCenter?.(newValue as OptionsCenter[])
            }
            placeholder="Centro"
            options={restrictionCenter}
            storageKey="selectedCenter"
            setInputValue={setCenterInputValue}
            inputValue={centerInputValue}
            setSelectedOptionsT={setSelectedOptionsT}
            clearState={clearCenter}
            isCenter={true}
            onSearchCenter={handleCenterSearch}
            isReadOnly={false}
          />
        </div>

        <div>
          <InputCheckBox
            value={selectedOptionsStatus || []}
            onChange={(_, newValue) =>
              setSelectedOptionsStatus?.(newValue as OptionsStatus[])
            }
            placeholder="Status"
            options={restriction}
            storageKey="selectedStatus"
            setInputValue={setInputValue}
            inputValue={inputValue}
            setSelectedOptionsT={setSelectedOptionsT}
            clearState={clearState}
            isReadOnly={true}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <CalendarInput
            key={calendarKey}
            value={dateRange}
            img={CalendarFilter}
            onChange={setDateRange}
            onDateChange={(from, to) => {
              handleDateChange(from, to);
              setStartDateLocal(from);
              setEndDateLocal(to);
            }}
            isOpen={isCalendarOpen}
            setIsOpen={setIsCalendarOpen}
            onDateTypingChange={handleTypingChange}
            placeholder={"Data de Entrada"}
          />

          {dateError && (
            <ContainerError
              id="calendar-date-error containerErro"
              label={dateError}
              icon={IconAlert}
              backgroudError="#FFD9D9"
              widthError="257px"
              colorError="#000000"
              classAuxiliar="positionError"
            />
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <CalendarInput
            key={quizCalendarKey}
            value={quizDateRange}
            img={CalendarFilter}
            onChange={setQuizDateRange}
            onDateChange={(from, to) => {
              handleQuizDateChange(from, to);
              setClassificationQuizStartDateLocal(from);
              setClassificationQuizFinishDateLocal(to);
            }}
            isOpen={isQuizCalendarOpen}
            setIsOpen={setIsQuizCalendarOpen}
            onDateTypingChange={handleQuizTypingChange}
            placeholder="Data Final do Laudo"
          />

          {quizDateError && (
            <ContainerError
              id="quiz-calendar-date-error containerErro"
              label={quizDateError}
              icon={IconAlert}
              backgroudError="#FFD9D9"
              widthError="257px"
              colorError="#000000"
              classAuxiliar="positionError"
            />
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <CalendarInput
            key={approvalCalendarKey}
            value={approvalDateRange}
            img={CalendarFilter}
            onChange={setApprovalDateRange}
            onDateChange={(from, to) => {
              handleApprovalDateChange(from, to);
              setClassificationApprovalStartDateLocal(from);
              setClassificationApprovalEndDateLocal(to);
            }}
            isOpen={isApprovalCalendarOpen}
            setIsOpen={setIsApprovalCalendarOpen}
            onDateTypingChange={handleApprovalTypingChange}
            placeholder="Data de Aprovação"
          />

          {approvalDateError && (
            <ContainerError
              id="approval-calendar-date-error containerErro"
              label={approvalDateError}
              icon={IconAlert}
              backgroudError="#FFD9D9"
              widthError="257px"
              colorError="#000000"
              classAuxiliar="positionError"
            />
          )}
        </div>

        {isTax && (
          <>
            <div>
              <InputCheckBox
                value={selectedOptionsFlag || []}
                onChange={(_, newValue) =>
                  setSelectedOptionsFlag?.(newValue as OptionsFlag[])
                }
                placeholder="Flag"
                options={optionsFlag}
                storageKey="selectedFlag"
                setInputValue={setInputValue}
                inputValue={inputValue}
                setSelectedOptionsT={setSelectedOptionsT}
                clearState={clearFlag}
                isReadOnly={true}
              />
            </div>
            <div>
              <InputCheckBox
                value={selectedOptionsHarmon || []}
                onChange={(_, newValue) =>
                  setSelectedOptionsHarmon?.(
                    newValue as unknown as OptionsHarmon[]
                  )
                }
                placeholder="Desarmonizado"
                options={optionsHamonizado}
                storageKey="selectedHarmon"
                setInputValue={setInputValue}
                inputValue={inputValue}
                setSelectedOptionsT={setSelectedOptionsT}
                clearState={clearHarmon}
                isReadOnly={true}
              />
            </div>
          </>
        )}

        <div style={{ display: "flex", marginTop: 3 }}>
          {handleFilter && (
            <ButtonGeneric
              img={Filter}
              title="Aplicar filtros"
              colorTitle="#FFFFFF"
              background=""
              style="buttonHeading"
              onClick={() => {
                handleFilter();
                setFilter(true);
              }}
              disabled={isFilterButtonDisabled}
            />
          )}

          <div style={{ marginLeft: 10 }}>
            <ButtonGeneric
              img={LixoIcon}
              title="Limpar filtros"
              colorTitle="#007BC0"
              background=""
              style="buttonLixo"
              onClick={() => {
                clearFilters();
                setFilter(false);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Filters;
